/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable, computed} from 'mobx';

export default class Address {
  @observable street: string;
  @observable zip_code: string;
  @observable city: string;
  @observable country: string = 'CH';
  @observable state: string;

  constructor(json?: any) {
    if(json) {
      this.street = json.street;
      this.zip_code = json.zip_code;
      this.city = json.city;
      this.state = json.state;
      this.country = json.country || 'CH';
      this.state = json.state;
    }
  }
  
  isValid(field: string): boolean {
    return field && field.trim().length > 0;
  }
  
  @computed get valid(): boolean {
    return this.isValid(this.street)
      && this.isValid(this.zip_code)
      && this.isValid(this.city)
      && this.isValid(this.country);
  }
  
  @computed get invalid(): boolean {
    return !this.valid;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Address.js